import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { authRoutes, publicRoutes, userRoute } from "./routes/index"; // adjust the path if needed
import ProtectedRoute from "./pages/Authentication/ProtectedRoute";
import Layout from "./component/Layouts/Layout"
const isAuthenticated = () => {
  return !!localStorage.getItem("token"); // or your auth check
};

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map(({ path, component }, idx) => (
          <Route key={idx} path={path} element={component} />
        ))}
        {userRoute.map(({ path, component}, idx) => (
          <Route key={idx} path={path} element={component}/>
        ))}
        {/* Protected Routes */}
        {authRoutes.map(({ path, component }, idx) => (
          <Route element={<ProtectedRoute />}>
          <Route
            key={idx}
            path={path}
            element={isAuthenticated() ? component : <Navigate to="/login" replace />}
          />
          </Route>
        ))}

        {/* Default route */}
        <Route path="*" element={<Navigate to={isAuthenticated() ? "/dashboard" : "/login"} />} />
      </Routes>
    </Router>
  );
};

export default App;
